export class GetUser {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(companyUserId) {
        console.log("get repository", companyUserId)
      return await this.userRepository.getUser(companyUserId);
    }
  }